
import { Auth } from "aws-amplify";

const ACCESSJWTTOKEN = "ACCESSJWTTOKEN";
const IDJWTTOKEN = "IDJWTTOKEN";
const USERNAME = "USERNAME";
const USERATTRIBUTES = "USERATTRIBUTES";
const USERGROUPS = "USERGROUPS"
const USER = "USER"
const TOKEN = "TOKEN";

export function createSession(user,userName) {
    console.log("sessionUtil:createSession:creating session");
    //user.signInUserSession.accessToken.jwtToken
    sessionStorage.setItem(ACCESSJWTTOKEN, JSON.stringify(user.signInUserSession.accessToken.jwtToken));
    sessionStorage.setItem(IDJWTTOKEN, JSON.stringify(user.signInUserSession.idToken.jwtToken));
    sessionStorage.setItem(TOKEN, user.signInUserSession.idToken.jwtToken);
    
    sessionStorage.setItem(USERATTRIBUTES, JSON.stringify(user.attributes));
    sessionStorage.setItem(USERNAME,userName);
    let payload = user.signInUserSession.idToken.payload;
    sessionStorage.setItem(USERGROUPS, JSON.stringify(payload["cognito:groups"]));

    sessionStorage.setItem(USER, user);

    console.log("Logged in user detail");
  
    
}

export function invalidateSession(){
    console.log("sessionUtil:invalidateSession:removing session info")
    sessionStorage.removeItem(ACCESSJWTTOKEN);
    sessionStorage.removeItem(IDJWTTOKEN);
    sessionStorage.removeItem(USERATTRIBUTES);
    sessionStorage.removeItem(USERNAME);
    sessionStorage.removeItem(USERGROUPS);
    sessionStorage.removeItem(TOKEN);

    const user = sessionStorage.getItem(USER)
    Auth.signOut();
    console.log("Logged out")

    sessionStorage.removeItem(USER);

}

export function isUserLoggedIn(){
    if(sessionStorage.getItem(IDJWTTOKEN) != null){
        // console.log("sessionUtil:isUserLoggedIn:User is logged in");
        return true;
    }
        
    console.log("sessionUtil:isUserLoggedIn:User is not logged");
    return false;
}

export function getIDToken() {
    return JSON.parse(sessionStorage.getItem(IDJWTTOKEN));
}



export function getLoggedInUserName(){
    let userName = "";
    try {
        userName = sessionStorage.getItem(USERNAME);
    } 
    catch(error){
        console.error(error.message);
    }
    return userName;
}
/*{"custom:tenantId":"AM2000",
    "sub":"cd80ee27-3abc-463d-9fc6-8a8bcac22c15",
    "custom:userName":"maheshhbhat@gmail.com",
    "custom:phoneNumber":"+12028932736",
    "custom:companyName":"MindHashmap"}*/
export function getLoggedInUserDetail(){
   
    let user = JSON.parse(sessionStorage.getItem(USERATTRIBUTES));
    
    return user;

}

export function getLoggedInUserTenantID(){
    let userAtt = JSON.parse(sessionStorage.getItem(USERATTRIBUTES));
    return userAtt["custom:tenantId"];
  
}

export function getLoggedInUserGroup(){
   let userGroups =  JSON.parse(sessionStorage.getItem(USERGROUPS));
   return userGroups;
}




